import { all } from "redux-saga/effects";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { billsSlice } from "../app/modules/Bills/_redux/billsSlice";
import { proposalsSlice } from "../app/modules/Bills/_redux/proposalsSlice";
import { teamsSlice } from "../app/modules/Teams/_redux/teamsSlice";
import { invitationsSlice } from "../app/modules/Invitations/_redux/invitationsSlice";
import { combineReducers } from "@reduxjs/toolkit";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  bills: billsSlice.reducer,
  proposals: proposalsSlice.reducer,
  teams: teamsSlice.reducer,
  invitations: invitationsSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export function* rootSaga() {
  yield all([auth.saga()]);
}
